import { SHORT_VIDEO_API } from '@/configs/api'
import { STATUS_RESPONSES } from '@/configs/settings'
import { updateAppContext } from '~/store/app-context'

export default ($axios) => ({
    /**
     * Get detail of short video
     * @param {*} id
     * @returns
     */
    async detail({ id, queryParams }) {
        const {
            data: { code, data, message },
        } = await $axios.post(SHORT_VIDEO_API.DETAIL, {
            id,
            queryParams,
        })
        if (code === STATUS_RESPONSES.SUCCESS && data.overlayData && Array.isArray(data.overlayData.options)) {
            data.overlayData.options = data.overlayData.options.sort((a, b) => {
                return parseFloat(a.optionNumber) - parseFloat(b.optionNumber)
            })
        }
        return { code, data, message }
    },

    /**
     * Get detail of playlist
     * @param {*} playListId
     * @returns
     */
    async playlistDetail(playListId, pageSize = 10, pageNum = 1, sortBy = []) {
        const {
            data: { code, data, message },
        } = await $axios.post(SHORT_VIDEO_API.PLAYLIST, {
            pageSize,
            pageNum,
            sortBy,
            playListId,
        })
        if (data) {
            updateAppContext('playlist', {
                [playListId]: {
                    id: data.id,
                    title: data.title,
                    organizationId: data.organizationId,
                    createdAt: data.createdAt,
                },
            })
        }

        return { code, data, message }
    },

    /**
     * Track view
     * @param {*} shortVideoId
     * @param {*} playListId
     * @param {*} viewerId
     * @param {*} userId
     * @param {*} trackedTime
     * @param {*} organizationId
     * @returns
     */
    async trackView(
        shortVideoId,
        playlistId,
        viewerId,
        organizationId = 0,
        userId = 0,
        trackedTime = Math.floor(Date.now() / 1000)
    ) {
        const {
            data: { code, data, message },
        } = await $axios.post(SHORT_VIDEO_API.VIEW, {
            shortVideoId,
            playlistId,
            viewerId,
            userId,
            organizationId: parseInt(organizationId),
            trackedTime,
        })
        return { code, data, message }
    },

    /**
     * Track interaction
     * @param {*} url
     * @param {*} baseURL
     * @param {*} shortVideoId
     * @param {*} playlistId
     * @param {*} viewerId
     * @param {*} organizationId
     * @param {*} ctaClickTrackings
     * @param {*} shareTrackings
     * @param {*} viewTracking
     * @param {*} ref
     * @returns
     */
    async trackInteraction(
        url = SHORT_VIDEO_API.TRACK_INTERACTION,
        baseURL = process.env.BASE_API,
        shortVideoId,
        playlistId,
        viewerId,
        organizationId = 0,
        ctaClickTrackings = [],
        shareTrackings = [],
        viewTracking = {},
        ref = ''
    ) {
        const {
            data: { code, data, message },
        } = await $axios.post(
            url,
            {
                ref,
                shortVideoId,
                playlistId,
                viewTracking,
                viewerId,
                ctaClickTrackings,
                shareTrackings,
                organizationId: parseInt(organizationId),
            },
            { baseURL: baseURL }
        )
        return { code, data, message }
    },

    /**
     *
     * @param {*} shortVideoId
     * @param {*} shortVideoPollingOptionId
     * @returns
     */
    async submitPoll(shortVideoId, shortVideoPollingOptionId) {
        const {
            data: { code, data, message },
        } = await $axios.post(SHORT_VIDEO_API.SUBMIT_POLL, {
            shortVideoId,
            shortVideoPollingOptionId,
        })
        return { code, data, message }
    },

    /**
     *
     * @param {*} shortVideoId
     * @returns
     */
    async getPollAnserResult(shortVideoId) {
        const {
            data: { code, data, message },
        } = await $axios.post(SHORT_VIDEO_API.POLL_ANSWER_RESULT, {
            shortVideoId,
        })
        if (data && Array.isArray(data.options)) {
            data.options = data.options.sort((a, b) => {
                return parseFloat(a.optionNumber) - parseFloat(b.optionNumber)
            })
        }
        return { code, data, message }
    },

    /**
     *
     * @param {*} shortVideoId
     * @param {*} questionId
     * @param {*} answerDefault
     * @returns
     */
    async anwserDefaultQuestion(shortVideoId, questionId, answerDefault) {
        const {
            data: { code, data, message },
        } = await $axios.post(SHORT_VIDEO_API.ANSWER_DEFAULT_QUESTION, {
            shortVideoId,
            questionId,
            answerDefault,
        })
        return { code, data, message }
    },

    /**
     *
     * @param {*} shortVideoId
     * @param {*} questionId
     * @param {*} answerFollowup
     * @returns
     */
    async anwserFollowUpQuestion(shortVideoId, questionId, answerFollowup) {
        const {
            data: { code, data, message },
        } = await $axios.post(SHORT_VIDEO_API.ANSWER_FOLLOW_UP_QUESTION, {
            shortVideoId,
            questionId,
            answerFollowup,
        })
        return { code, data, message }
    },

    /**
     *
     * @param {*} shortVideoId
     * @returns
     */
    async getQuestionAndAnswerResult(shortVideoId) {
        const {
            data: { code, data, message },
        } = await $axios.post(SHORT_VIDEO_API.QNA_ANWSER_RESULT, {
            shortVideoId,
        })
        return { code, data, message }
    },

    /**
     * Track interaction
     * @param {*} url
     * @param {*} baseURL
     * @param {*} shortVideoId
     * @param {*} details
     * @param {*} playlistId
     * @param {*} organizationId
     * @param {*} userDisplayName
     * @param {*} playlistStoryType
     * @param {*} device
     * @param {*} domain
     * @param {*} ref
     * @returns
     */
    async trackIOT(url = SHORT_VIDEO_API.TRACK_INTERACTION, baseURL = process.env.BASE_API, payload) {
        const {
            data: { code, data, message },
        } = await $axios.post(url, { ...payload }, { baseURL: baseURL })
        return { code, data, message }
    },

    /**
     * Track Shopify Shopping
     */
    async trackShopping(payload, axiosOptions = {}) {
        const {
            data: { code, data, message },
        } = await $axios.post(
            SHORT_VIDEO_API.TRACK_SHOPPING,
            { ...payload },
            { baseURL: `${process.env.TRACKING_ENDPOINT}/api`, ...axiosOptions }
        )
        return { code, data, message }
    },

    /**
     * Unlike video
     */
    async likeVideo(payload, axiosOptions = {}) {
        const {
            data: { code, data, message },
        } = await $axios.post(
            SHORT_VIDEO_API.LIKE_VIDEO,
            { ...payload },
            { baseURL: `${process.env.TRACKING_ENDPOINT}/api`, ...axiosOptions }
        )
        return { code, data, message }
    },

    /**
     * Like Video
     */
    async unLikeVideo(payload, axiosOptions = {}) {
        const {
            data: { code, data, message },
        } = await $axios.post(
            SHORT_VIDEO_API.UNLIKE_VIDEO,
            { ...payload },
            { baseURL: `${process.env.TRACKING_ENDPOINT}/api`, ...axiosOptions }
        )
        return { code, data, message }
    },
})
